import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Select, DateUtils, OPPureComponent, PlusButton } from '..';
import { THEME, __WEB__, COLOR, FONT } from '../../../constants/styles';

import moment from 'moment';

export default class AppointmentsScheduleForm extends OPPureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedDays: {},
      selectedScheduleId: null,
      selectedSchedule: null,
      scheduleOptions: [],
    };
  }

  setStateFromSchedule() {
    const props = this.props;
    const state = this.state;
    if (!props.schedules?.length) return;

    const scheduleOptions = props.schedules.map((s) => ({
      label: props.scheduleOptionLabel?.(s) || `${DateUtils.daysOfWeekLabel(s.days)}`,
      id: s.days.join(),
    }));
    const selectedSchedule =
      props.schedules?.find((s) => s.days.join() === state.selectedScheduleId) || null;
    this.setState({
      scheduleOptions,
      selectedSchedule,
    });
  }

  componentDidMount() {
    const props = this.props;
    const selectedScheduleId = props.schedules?.[0]?.days?.join() || undefined;
    this.setState({ selectedScheduleId });
  }

  componentDidUpdate(prevProps, prevState) {
    const props = this.props;
    if (this.state.selectedScheduleId !== prevState.selectedScheduleId) {
      this.setStateFromSchedule();
    }
    if (props.schedules !== prevProps.schedules) {
      if (props.nextScheduleId) {
        if (
          props.schedules?.find((s) => {
            return s.days?.join() === props.nextScheduleId;
          })
        ) {
          this.setState({ selectedScheduleId: props.nextScheduleId }, this.setStateFromSchedule);
        } else {
          this.setState({ selectedScheduleId: props.schedules?.[0]?.days?.join() || undefined });
        }
      } else if (this.state.selectedScheduleId === undefined) {
        this.setState({ selectedScheduleId: props.schedules?.[0]?.days?.join() || undefined });
      } else {
        this.setStateFromSchedule();
      }
    }
    const selectedSchedule = this.state.selectedSchedule;
    if (selectedSchedule !== prevState.selectedSchedule) {
      const selectedDays =
        (selectedSchedule?.days || []).reduce((result, current) => {
          result[current] = true;
          return result;
        }, {}) || {};
      this.props.onSelectSchedule({ selectedSchedule, selectedDays });
    }
  }

  handleSelectSchedule = (val) => {
    this.setState({ selectedScheduleId: val.id });
  };

  clearSelectedSchedule = () => {
    this.setState({ selectedScheduleId: null });
  };

  render() {
    const props = this.props;
    const selectedScheduleOption = this.state.scheduleOptions.find(
      (o) => o.id === this.state.selectedScheduleId
    );
    return (
      <View style={{}}>
        {!!this.state.scheduleOptions?.length && (
          <View
            style={[
              THEME.basicRow,
              { flex: 1, zIndex: 1000, justifyContent: 'center', alignItems: 'center' },
            ]}
          >
            <Select
              required={true}
              editable={true}
              closeOnSelect={true}
              onFocus={null}
              options={this.state.scheduleOptions}
              label={'Schedules'}
              placeholder="New Schedule"
              value={selectedScheduleOption || null}
              onValue={this.handleSelectSchedule}
              webMode={true}
              containerStyle={{ flex: 1, marginRight: 15 }}
              nativeContainerStyle={{ flex: 1, marginRight: 15, paddingTop: 5 }}
            />
            <PlusButton
              onPress={!props.readOnly ? this.clearSelectedSchedule : null}
              buttonStyle={{ shadowColor: 'transparent' }}
            />
          </View>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({});
